import { useCustomTranslation } from '../../../localization/hooks/useCustomTranslation';
import { moduleId } from '../config';

export const useMyBusTranslation = (keyPrefix: string) =>
  useCustomTranslation({ moduleId, keyPrefix });
